// extracted by mini-css-extract-plugin
module.exports = {"arrow":"styles-m__arrow__9YN2G","arrow--open":"styles-m__arrow--open__37tuF"};